import { render } from "./ProductsOverview.vue?vue&type=template&id=14af019f&scoped=true&ts=true"
import script from "./ProductsOverview.vue?vue&type=script&lang=ts"
export * from "./ProductsOverview.vue?vue&type=script&lang=ts"

import "./ProductsOverview.vue?vue&type=style&index=0&id=14af019f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14af019f"]])

export default __exports__